
import { CheckoutPageModel } from '@ViewModels/CheckoutPageModel'
import { StoreCheckoutDto } from '@ViewModels/StoreCheckoutDto'
import Vue from 'vue'

export default Vue.extend({
   name: 'PaymentInputSummary',
   data() {
      return {
         step: 'payment',
      }
   },

   computed: {
      visible(): boolean {
         return (
            this.$store.state.step !== this.step &&
            this.$store.state.viewedSteps.includes(this.step)
         )
      },
      modelData(): CheckoutPageModel {
         return this.$store.state.modelData
      },
      purchase(): StoreCheckoutDto {
         return this.$store.state.purchase
      },
      schoolName(): string {
         return this.$store.getters.schoolName
      },
      description(): string {
         let description = ''
         if (this.purchase.IsSchoolInvoicing) {
            description = 'Invoice my school'
            if (this.purchase.SchoolOrderNumber) {
               description += ', Order Number ' + this.purchase.SchoolOrderNumber
            }
         } else {
            if (this.last4Digits.length === 0) {
               description = `Credit card (not yet entered)`
            } else {
               description = `Credit card ending in ${this.last4Digits}`
            }
         }

         return description
      },
      last4Digits(): string {
         const cardNumber = this.purchase.CardNumber
         if (cardNumber.length < 4) {
            return cardNumber
         }
         return cardNumber.substring(cardNumber.length - 4)
      },
   },
   methods: {
      change() {
         this.$store.commit('setStep', this.step)
      },
   },
})
